import { Typography } from 'shared/ui'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { BOOKING_REMINDERS_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/bookingWidgetStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/styles.module.scss'

type IBookingStep4Props = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const BookingStep4 = ({ focusedIndex, onSelect }: IBookingStep4Props) => (
  <div className={styles.list}>
    {BOOKING_REMINDERS_OPTIONS.map((item, index) => {
      const isFocused = index === focusedIndex

      return (
        <WidgetItem
          key={item.id}
          isFocused={isFocused}
          badgeIndex={index}
          onClick={() => onSelect(index)}
        >
          <Typography variant={'body-rg-regular'} ariaLabel={item.label}>
            {item.label}
          </Typography>
        </WidgetItem>
      )
    })}
  </div>
)
